'use client'
import React, { forwardRef, useContext } from 'react'
import { LanguageContext } from '../../../providers/LanguageProvider'
import en from '../../../languages/en'

const propsToDelete = [
  'borderColor',
  'backgroundColor',
  'variant',
  'roundness',
  'fontSize',
  'disabledColor',
  'size',
  'customStyle',
]

/**
 * The Text functional component can be used by two ways
 * 1) <Text tid='test' />
 * Here tid means translated id which is required translation
 */

const Text = ({ tid }) => {
  const { dictionary = {} } = useContext(LanguageContext)
  if (!dictionary[tid]) {
    return en[tid] || tid
  }
  return dictionary[tid]
}

/**
 * To translate input place holders use InputText translatedId(tid) is required
 *
 * As TranslatedInput is being used with styled hoc, using forwardRef to forward the ref
 * to the DOM elements instead of function components
 */

const TranslatedInput = forwardRef(function TranslatedInput(props, ref) {
  let { placeholder } = props
  const { placeholderId, isRequired, showSearch, ...rest } = props
  // To resolve console warning for unrecognized attributes used for styled components
  if (rest.customAttributes) {
    delete rest.customAttributes
  }

  /**
   * To resolve browser warnings
   * Resolves `React does not recognize the `prop` prop on a DOM element.`
   */
  Object.keys(rest).forEach(k => {
    if (propsToDelete.includes(k)) {
      delete rest[k]
    }
  })

  if (placeholder) {
    throw new Error(
      'Do not pass placeholder string instead use placeholderId prop to get translated placeholder All the placeholderIds can be found in language directory(en.js)'
    )
  }
  placeholder = ''
  const { dictionary = {} } = useContext(LanguageContext)
  if (!dictionary[placeholderId]) {
    placeholder = en[placeholderId] || placeholderId
  } else {
    placeholder = dictionary[placeholderId]
  }
  if (isRequired && en[placeholderId]) {
    placeholder = placeholder.concat('*')
  }
  return <input {...rest} placeholder={placeholder} ref={ref} />
})

const getTranslateText = textId => {
  const { dictionary = {} } = useContext(LanguageContext) // hook inside a function??? this is not allowed in React!!!!!!
  let text = ''
  if (!dictionary[textId]) {
    text = en[textId] || textId
  } else {
    text = dictionary[textId]
  }
  return text
}

/**
 * To translate image alt text use ImageText translatedId(tid) is required
 */

const TranslatedImage = forwardRef(function TranlatedImage(props, ref) {
  let { alt } = props
  const { altId, ...rest } = props

  if (alt) {
    throw new Error(
      'Do not pass alt string instead use altId prop to get translated alt text All the altIds can be found in language directory(en.js)'
    )
  }
  alt = ''
  const { dictionary = {} } = useContext(LanguageContext)
  if (!dictionary[altId]) {
    alt = en[altId] || altId
  } else {
    alt = dictionary[altId]
  }
  return <img {...rest} alt={alt} ref={ref} />
})

export { Text, TranslatedInput, TranslatedImage, getTranslateText }
